import React from 'react';
import { motion } from 'framer-motion';
import { FaWallet, FaExchangeAlt, FaLock, FaRocket } from 'react-icons/fa';
import './MainContent.css';

const HowToBuy = () => {
  // Steps data
  const steps = [
    {
      icon: <FaWallet />,
      title: "Set Up Your Wallet",
      description: "Download and install MetaMask or another supported wallet. Create a new wallet or import your existing one."
    },
    {
      icon: <FaExchangeAlt />,
      title: "Get Some Solana",
      description: "Purchase SOL from an exchange like Coinbase, Binance, or KuCoin and transfer it to your wallet."
    },
    {
      icon: <FaLock />,
      title: "Connect to WiggaSwap",
      description: "Visit our decentralized exchange at swap.wiggachain.ai and connect your wallet securely."
    },
    {
      icon: <FaRocket />,
      title: "Swap for W2",
      description: "Enter the amount of SOL you want to swap, confirm the transaction, and welcome to the Wigga family!"
    }
  ];
  
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  
  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6
      }
    }
  };
  
  return (
    <section id="how-to-buy" className="how-to-buy-section">
      <div className="section-container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">How to <span className="gradient-text">Buy</span></h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Follow these simple steps to get your hands on WIGGA tokens
          </p>
        </motion.div>
        
        <motion.div 
          className="steps-container"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {steps.map((step, index) => (
            <motion.div 
              key={index} 
              className="step-card"
              variants={itemVariants}
            >
              <div className="step-number">{index + 1}</div>
              <div className="step-icon">{step.icon}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
              
              {index < steps.length - 1 && (
                <div className="step-connector">
                  <div className="connector-line"></div>
                  <div className="connector-arrow"></div>
                </div>
              )}
            </motion.div>
          ))}
        </motion.div>
        
        <motion.div 
          className="buy-now-container"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
         <div className="buy-card">
  <div className="buy-card-content">
    <h3 className="buy-card-title">Ready to escape poverty, brokie?</h3>
    <p className="buy-card-text">
      $W2 launching at a laughable 5k market cap. We're not just going to the moon - we're taking this bitch to another galaxy. Turning pocket change into generational wealth.
    </p>
    <div className="token-info">
      <div className="token-stat">
        <span className="token-value">1,000,000,000</span>
        <span className="token-label">Tokens For The Taking</span>
      </div>
      <div className="token-stat">
        <span className="token-value">100%</span>
        <span className="token-label">Pure Unadulterated Pump</span>
      </div>
      <div className="token-stat">
        <span className="token-value">$0.00000004</span>
        <span className="token-label">Future Millionaire Entry Price</span>
      </div>
    </div>
    <button className="buy-button">
      <span>APE INTO $W2 OR STAY POOR</span>
      <span className="button-glow"></span>
    </button>
  </div>
  <div className="buy-card-glow"></div>
</div>
        </motion.div>
      </div>
      
      <div className="section-background">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
      </div>
    </section>
  );
};

export default HowToBuy;